import PropTypes from "prop-types";
import React, {
    useCallback,
    useState,
} from "react";

import AutoJudgementSaveBtnComp from "../components/auto-judgement-save-btn/auto-judgement-save-btn.jsx";

const AutoJudgementSaveBtn = function (props) {
    const {vm,text} = props;
    const onClick  = function(){
        window.top.postMessage({
            name: 'saveAutoJudgementConfig',
            data: vm.toJSON()
        }, '*');
    };

    return <AutoJudgementSaveBtnComp text={text} onClick={onClick} />;
};

AutoJudgementSaveBtn.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.strgin,
};

export default AutoJudgementSaveBtn;
